import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@telus-uds/components-web';
import { ModalWidthOverride, StickyOrderModalHeader } from '../modalOverrides';

const ModalCustom = ({
  open = false,
  setOpen,
  header = '',
  children,
  customStyles = null,
  hideCloseButton = false, // eslint-disable-line no-unused-vars
  wide = false
}) => {
  const handleClose = () => {
    setOpen();
  };

  return (
    <>
      {open && wide && <ModalWidthOverride width="1024px" />}
      {open && <StickyOrderModalHeader />}
      <Modal
        isOpen={open}
        onClose={handleClose}
        variant={{ width: 'xl' }}
        heading={header || undefined}
      >
        <div style={{ ...(typeof customStyles === 'object' ? customStyles : {}) }}>
          {children}
        </div>
      </Modal>
    </>
  );
};

ModalCustom.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.shape({}),
  hideCloseButton: PropTypes.bool,
  wide: PropTypes.bool
};

export default ModalCustom;
